export default {
    type: 'widget',
    config: {
        defaultWidth: 80,
        icon: 'dice',
        demotable: true
    },
    default: {
        label: 'Plays'
    },
    unique: [],
    sort: 'plays',
    lang: {
        name: 'Total Plays',
        views: ['list', 'sheet', 'grid'],
        category: ['User', 'Plays'],
        description: 'Number of plays across all-time or a specific time period.'
    },
    filters: ['total.plays']
}